class PeraSigner {
    constructor(connectedAddress, client) {
        this.connectedAddress = connectedAddress;
        this.client = client;
    }
    signData(data) {
        return this.client.signData(data, this.connectedAddress);
    }
    signTransaction(txs) {
        return this.client.signTransaction(txs);
    }
}

export { PeraSigner };
